module.exports = __webpack_public_path__ + "static/media/mobile.1f7e5ab2.svg";